import React from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: 'transparent';
  border-radius: 5px;
  width: 80%;
  margin: 0 auto;
//   box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h1`
  font-size: 24px;
  color: ${(props) => props.colors.labelText};
  margin-bottom: 20px;
`;

const DateLabel = styled.span`
  font-size: 14px;
  color: ${(props) => props.colors.textSecondary};
  margin-bottom: 20px;
  display: block;
`;

const Body = styled.div`
  font-size: 16px;
  color: ${(props) => props.colors.labelText};
  line-height: 1.6;
  width: 100%;

  p {
    margin-bottom: 1em;
  }
`;

const BackLink = styled.a`
  font-size: 14px;
  color: ${(props) => props.colors.buttonBackground};
  text-decoration: underline;
  font-weight: bold;
  margin-top: 20px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const AnnouncementDetailsPage = ({ colors }) => {
  // Using React Router's location to get passed state (announcement details)
  const location = useLocation();
  const { announcement } = location.state || {};
  const formattedAnnouncement = announcement || {};

  // If no announcement details are passed, show a fallback
  if (!announcement) {
    return (
      <DetailsContainer colors={colors}>
        <Title colors={colors}>Announcement Not Found</Title>
        <Body colors={colors}>
          The announcement details could not be retrieved. Please go back and try again.
        </Body>
        <BackLink
          colors={colors}
          href="/admincentral/announcements"
        >
          Go Back to Announcements
        </BackLink>
      </DetailsContainer>
    );
  }

  const formatDate = (dateString) => {
    if (!dateString) return "Date unavailable";
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return "Date unavailable";
    return date.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  };


  return (
    <DetailsContainer colors={colors}>
      <Title colors={colors}>{formattedAnnouncement.title}</Title>
      <DateLabel colors={colors}>
        {formatDate(
          formattedAnnouncement.announcement_date || formattedAnnouncement.inserted
        )}
      </DateLabel>
      <Body
        colors={colors}
        dangerouslySetInnerHTML={{
          __html: formattedAnnouncement.announcement || formattedAnnouncement.body || "",
        }}
      />
      <BackLink
        colors={colors}
        href="/admincentral/isafeadmins/dashboard"
      >
        {'<<'} Back to Announcements
      </BackLink>
    </DetailsContainer>
  );
};

export default AnnouncementDetailsPage;
